import { render, staticRenderFns } from "./DataHisPage.vue?vue&type=template&id=5e992d77&"
import script from "./DataHisPage.vue?vue&type=script&lang=js&"
export * from "./DataHisPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports